<div class="container-fluid">
  <div class="header-row">
    <div class="header-left">
      <div class="header-title">
        <span>
          {{tab_name}}
        </span>
        <button *ngIf="query" (click)="toggleQueryBox()" class="btn btn-link p-0 eye-btn">
          <i class="bi" [matTooltip]="showQueryBox ? 'Hide Query' : 'View Query'"
            [ngClass]="showQueryBox ? 'bi-eye-slash' : 'bi-eye'"
            matTooltipPosition="above">
          </i>
        </button>
      </div>
  
      <div *ngIf="showQueryBox && query" class="alert alert-info query-alert" role="alert">
        {{ query || 'No query found' }}
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12"  style="margin:20px;margin-top:0;" *ngIf="!isPopup">
      <!-- Only show description when not in popup mode -->
      <div *ngIf="!isPopup && (tabs$ | async)?.search_type=='company'">
        Below is the innovation activity of {{tab_name}} over the last 10 years. The chart shows the number of
        inventions published each year, and the table below shows the top keywords from recent inventions.
      </div>

      <div *ngIf="!isPopup && (tabs$ | async)?.search_type=='theme'">
        Below is the innovation activity in this technology area over the last 10 years. The chart shows the number of
        inventions published each year, and the table below shows the top keywords from recent inventions.
      </div>

      <br>
    </div>
    <div class="col m-10" >
      <div class="card keywords">
        <h3>Patent Activity Over Years (10y)</h3>

        <div class="alert alert-danger" role="alert" *ngIf="patent_activity_data_loading_failed">
        
          <p>
            Unfortunately, we weren't able to load the data. Please try again later, or for more assistance, please
            contact
            <a href="mailto:tech@quant-ip.com" style="color: blue">info&#64;quant-ip.com</a>.
          </p>
        </div>
        <div class="empty-state" *ngIf="showNoDataFound">
          <div class="empty-state-content">
            <i class="bi bi-search empty-state-icon"></i>
            <h4>No Recent Patent Activity</h4>
            <p> There haven't been any inventions published in the last 10 years to generate a patent activity graph.
            </p>
          </div>
        </div>
        
        <div class="spinner-border text-primary" role="status"
          *ngIf="patentActivityData.length==0 && !patent_activity_data_loading_failed && !showNoDataFound">
          <span class="visually-hidden">Loading...</span>
        </div>
        <div *ngIf="showPlot">
          <plotly-plot [data]="patentActivityPlot.data" [layout]="patentActivityPlot.layout"></plotly-plot>
        </div>
      </div>

    </div>
    <div class="col m-10" >

      <div class="card keywords" style="padding:15px;">

        <h3>Top Keywords (12m)</h3>
        <div class="alert alert-danger" role="alert" *ngIf="keywords_data_loading_failed">
          <p>
            Unfortunately, we weren't able to load the data. Please try again later, or for more assistance, please
            contact
            <a href="mailto:tech@quant-ip.com" style="color: blue">info&#64;quant-ip.com</a>.
          </p>
        </div>
        <div class="empty-state" *ngIf="showKeywordsNoDataFound">
          <div class="empty-state-content">
            <i class="bi bi-search empty-state-icon"></i>
            <h4>No Recent Keywords</h4>
            <p>There haven't been any inventions published in the last 12 months to generate keyword trends.
            </p>
          </div>
        </div>
        <div class="spinner-border text-primary" role="status"
          *ngIf="keywords.length==0 && !keywords_data_loading_failed && !showKeywordsNoDataFound">
          <span class="visually-hidden">Loading...</span>
        </div>
        <table class="table   table-hover table-condensed " *ngIf="keywords.length>0">
          <thead>
            <tr style="background-color: #96c242;">
              <th>Keyword</th>
              <th>No. of Inventions (12m)
                <i class="bi bi-info-circle" style="margin-left: 5px; cursor: pointer;"
                  [matTooltip]="'This represents the number of inventions published in the last 12 months with this  keyword in the patent document title.'"
                  matTooltipPosition="above">
                </i>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of keywords | paginate: {id:'pag_keywords', itemsPerPage: 10, currentPage: paginator_1_page }">
              <td>{{item.ti_kw}}</td>
              <td>{{item.invention_count}}</td>
            </tr>
          </tbody>
        </table>
        <pagination-controls id="pag_keywords" [maxSize]="5" (pageChange)="paginator_1_page = $event"
          style="align-items: flex-start;" *ngIf="keywords.length>0">
        </pagination-controls>


      </div>



    </div>

   

  </div>